module.exports = __webpack_public_path__ + "img/gleeder-logo.0c3294cb.svg";